module.exports = __webpack_public_path__ + "img/banner-area-comprador-institucional.568debc0.png";